import React from 'react'

import PropTypes from 'prop-types'

import {CondicionesDeUso, CondicionesDeUsoReserva, CookiesOtrosPartners, Transparency} from '@adv-mt/mt-react-markdown'

import Wrapper from '../wrapper.js'

const contentMap = {
  termsOfService: CondicionesDeUso,
  termsOfServiceReservation: CondicionesDeUsoReserva,
  transparency: Transparency,
  otherPartners: CookiesOtrosPartners
}

const MarkdownStatic = ({documentName, tenant, parser}) => {
  const Content = contentMap[documentName] ?? CondicionesDeUso

  return (
    <Wrapper>
      <Content tenant={tenant} parser={parser} />
    </Wrapper>
  )
}

MarkdownStatic.displayName = 'MarkdownStatic'

MarkdownStatic.propTypes = {
  documentName: PropTypes.string.isRequired,
  tenant: PropTypes.string,
  parser: PropTypes.func
}

export default MarkdownStatic
